import { FC, ReactNode } from "react";

export const FieldGroup: FC<{
  className?: string;
  children: ReactNode;
}> = ({ className = "", children }) => (
  <div className={`d-flex flex-column gap-4 ${className}`.trim()}>
    {children}
  </div>
);

export default FieldGroup;
